import React from 'react';
import FormLabel from '@material-ui/core/FormLabel'
import ResiduosCheckbox from './ResiduosCheckbox';

const ResiduosCheckboxGroup = ({data, handleSelectChange, handleInputText, name}) => (
  <div style={{ display: 'flex', flexDirection: 'column'}}>
    {<FormLabel component="legend">{name.split('.')[1]}</FormLabel>}
      {data.map((item, index) =>
        <ResiduosCheckbox
          item={item}
          name={name}
          handleSelectChange={handleSelectChange}
          handleInputText={handleInputText}
          key={index}
        />
      )}
  </div>
);

export default ResiduosCheckboxGroup;
